import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext({ config: {}, refresh: () => {} });

export const SiteProvider = ({ children }) => {
  const [config, setConfig] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site_config");
      setConfig(data || {});
    } catch (e) {
      console.error("site_config fetch failed", e);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <SiteCtx.Provider value={{ config, refresh }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
